export default {
  oma: {
    // land suitability
    landSuitibility: "Adecuación del Terreno",
    landSuitibilityReport: "Informe de Adecuación del Terreno",
    generateNewReport: "Generar Nuevo Informe",
    operatorName: "Nombre del Operador",
    issueDate: "Fecha de Emisión",
    chooseYourLocation: "Elija Su Ubicación",
    getLandEvaluation: "Obtener Evaluación del Terreno",
    downloadPdfReport: "Descargar informe en PDF",
    pleaseEnterCoordinateText:
      "Por favor ingrese las coordenadas (longitud y latitud) de la ubicación de la finca para ver su puntaje.",
    noRecordAvailable: "No hay resultados disponibles.",
    overallScoreForLand: "Puntaje General de Adecuación del Terreno",
    landEvaluation: "Evaluación del Terreno",
    unsuitable: "Inadecuado",
    marginally: "Marginalmente",
    suitable: "Adecuado",
    moderately: "Moderadamente",
    highly: "Altamente",
    back: "Volver",
    search: "Buscar",
    showResults: "Mostrar Resultados",

    // weather analysis
    weatherAnalysisReport: "Informes de Análisis Meteorológico",
    weatherAnalysis: "Análisis Meteorológico",
    getWeatherAnalysis: "Obtener Análisis Meteorológico",
    weatherReport: "Informe Meteorológico",
    filterByDate: "Filtrar por Fecha",
    insertCoordinateText:
      "Inserte las coordenadas de la ubicación de la finca (o árbol) arriba, o use el mapa a continuación para indicar la ubicación de la Finca (o árbol).",

    addTreeGeolocation: "Agregar Geolocalización del Árbol",
    editTreeGeolocation: "Editar Geolocalización del Árbol",
    plantationDate: "Fecha de Plantación",
    notes: "Notas",
    uploadTreeImages: "Subir Imágenes del Árbol",

    valueAtTheCoordinatesOfInterest: "Valor en la Coordenada de Interés",
    "Slope (%)": "Pendiente (%)",
    "Soil texture (USDA class)": "Textura del suelo (clase USDA)",
    "Coarse fragments (vol%)": "Fragmentos gruesos (vol%)",
    Land: "Tierra",
    "Artificial surfaces (type)": "Superficies artificiales (tipo)",
    "Proximity to Type 1 and 2 Roads (meters)":
      "Proximidad a carreteras de Tipo 1 y 2 (metros)",
    "Soil Chemical Properties": "Propiedades químicas del suelo",
    "Soil Physical Properties": "Propiedades físicas del suelo",
    "Soil organic carbon (%)": "Carbono orgánico del suelo (%)",
    "Soil pH": "pH del suelo",
    "Soil salinity (ECe))": "Salinidad del suelo (ECe)",
    "Mean annual temperature (°C)": "Temperatura media anual (°C)",
    Weather: "Clima",
    "Mean minimum temperature of coldest month (°C)":
      "Temperatura mínima media del mes más frío (°C)",
    "Mean annual precipitation (mm)": "Precipitación anual media (mm)",
    OrDragDrop: "o arrastre y suelte aquí",
    removeFile: "Eliminar archivo",

    importCSVFormat: "Importar Formato CSV",
    importGeoJsonFormat: "Importar Formato GeoJSON",
    importShapeFilesFormat: "Importar Formato de Archivos de Forma",
    importXLSFormat: "Importar Formato XLS",
    importGeobufFormat: "Importar Formato Geobuf",
    importGeoPackageFormat: "Importar Formato GeoPackage ",
    importTopoJsonFormat: "Importar Formato TopoJSON ",
    downloadCSVFormat: "Descargar como Formato CSV",
    downloadXLSFormat: "Descargar Formato XLS",
    downloadGeoJsonFormat: "Descargar Formato GeoJSON",
    downloadXMLFormat: "Descargar Formato XML",
    downloadTopoJSONFormat: "Descargar Formato TopoJSON",
    downloadGeobufFormat: "Descargar Formato Geobuf",
    downloadGeoPackageFormat: "Descargar Formato GeoPackage",
    downloadFileFormatTemplates: "Descargar Plantillas de Formato de Archivo",
    importantNote: "Nota Importante",
    fileName: "Nombre del archivo",
    importedOn : "Importado en", 
    status: "Estado",
    actions:  "Acciones",
    action:  "Acción",
    download:  "Descargar",
    import:  "Importar",
    history: "Historial",
  },
}